export const IconVisitor = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,2.1L12.6,2.1c5.8,0,10.5,4.7,10.5,10.5l0,0c0,5.8-4.7,10.5-10.5,10.5
		l0,0c-5.8,0-10.5-4.7-10.5-10.5l0,0C2.1,6.8,6.8,2.1,12.6,2.1z"
          fill="#3366FF"
        />
        <path
          d="M12.6,2.8L12.6,2.8
		c5.4,0,9.9,4.4,9.9,9.9l0,0c0,5.4-4.4,9.9-9.9,9.9l0,0c-5.4,0-9.9-4.4-9.9-9.9l0,0C2.8,7.2,7.2,2.8,12.6,2.8z"
          fill="none"
          stroke="#3366FF"
          strokeWidth="1.2904"
        />
        <path
          d="M11.3,18.4L8.2,8.2h2l2.6,8.4l2.6-8.4h2l-3.1,10.2H11.3z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  );
};
